module.exports = __webpack_public_path__ + "img/banner-betslip.37757c45.png";